<template lang="pug">
  div
    .container-listagem
      div.card-container
        h1 Processos com CAR gerado
      el-card.card-container(shadow="hover")
        filtro(
          @pesquisar="pesquisar",
          @limpar="clear",
          :showOs="false",
          :showMunicipios="false",
          :configuracaoFiltro="configuracaoFiltro",
          :filtroRapido="filtroRapido"
        )
      app-listagem(
        :has-refresh-button="true",
        :json-headers="colunas",
        :json-data="items",
        :totalElements="totalElements",
        :pagina="filtro.pagina",
        :hasFiltroRapido="false",
        :filtro="filtro",
        :textoButtonAssinatura="'Iniciar análise'",
        @atualizarFiltro="atualizarFiltro",
        @updateListagem="refresh",
        @changePage="changePage",
        @sort="sort",
        @executar="executar"
      )
</template>
<script>
import AppListagem from '@/components/AppListagem.vue'
import AppPaginacao from '@/components/AppPaginacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import Filtro from '@/components/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import axios from '@/utils/api'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {

  components: {
    AppListagem,
    Filtro,
    AppPaginacao
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('PROCESSOS_CAR_GERADO'),
      items: [],
      totalElements: 0,
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => false, ordem: 1, sortable: false, acoes: [] },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, sortable: false, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, sortable: false, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, sortable: false, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, sortable: false, acoes: [] },
        {
          id: 8, titulo: 'Ações', propriedade: 'tipo', ordem: 7, sortable: false, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Download CAR', icone: 'fa-download', codigo: 'DOWNLOAD_CAR', ordem: 1, show: () => true },
            { id: 2, nome: 'Regerar CAR', icone: 'fa-sync', codigo: 'REGERAR_CAR', ordem: 2, show: () => true }
          ]
        }
      ],
      configuracaoFiltro: {
        filtroResponsavel: [],
        filtroSituacao: ['ANALISTA_DE_OCUPACAO']
      }
    }
  },

  methods: {
    DOWNLOAD_CAR (_this, { item }) {
      window.open(`${process.env.ROOT_URL}geracao-car/${item.id}`, '_blank')
    },
    REGERAR_CAR (_this, { item }) {
      axios({
        method: 'PUT',
        url: `geracao-car/${item.id}`,
        data: {}
      })
        .then(() => {
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.SUCESSO_REGERAR_CAR
          )
        })
    }
  }
}
</script>
<style lang="scss" scoped>

  .card-container {
    margin: 20px;
    border-radius: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/manutencao/ProcessosComCarGerado.vue